import React from 'react';
import PhoneOld from '../phoneOld.png';

const PhoneIcon = () => {
  return <img src={PhoneOld} alt="" />;
};

export default PhoneIcon;
